import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./en.json";
import fr from "./fr.json";
import nl from "./nl.json";

// Get saved language from localStorage or use 'fr' as default
const savedLanguage = localStorage.getItem('appLanguage') || 'fr';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
      nl: { translation: nl },
    },
    lng: savedLanguage, // Use saved language or default to French
    fallbackLng: "fr", // Fallback to French
    interpolation: { escapeValue: false },
    debug: false,
    saveMissing: false,
  });

export default i18n;